import './c-icon-tabs.scss';
import template from './icon-tabs.vhtml';

export default {
	template,
	props: {
		tabs: {
			type: Array,
			required: true,
		},
		selected: {
			type: Number,
			required: true,
		},
		tagLine: {
			type: String,
			required: false,
		},
	},
	methods: {
		selectTab( index ) {
			this.$emit( 'select-tab', index );
		},
	},
};



// WEBPACK FOOTER //
// ./assets/_js/components/icon-tabs/icon-tabs.js